<!--<app-filters
  (onEnter)="receiveFilter($event)"
  (geFilter)="receiveFilterCompany($event)"
></app-filters>-->
<main>
  <section class="container_first">
    <app-my-companies-registred
      class="contenedor"
      [recieveCompanies]="companies"
    ></app-my-companies-registred>
  </section>
</main>
